import { Reducer } from 'interfaces'
import { DeviceAppState } from 'interfaces/device'
import { SetDeviceInfoAction } from 'actions/deviceActions'

const DEFAULT_STATE: DeviceAppState = {
  deviceId: null,
  deviceIdSum: null,
  appVersion: null,
}

export const deviceReducer: Reducer<DeviceAppState> = (prevState = DEFAULT_STATE, action) => {
  switch (action.type) {
    case SetDeviceInfoAction.type: {
      if (action.meta === 'fail') {
        return prevState
      }

      if (action.meta === 'request') {
        return {
          ...prevState,
          ...action.payload.params,
        }
      }

      return {
        ...prevState,
        ...action.payload.response,
      }
    }

  }
  return prevState
}

